/* global angular, TweenMax */
angular.module('ua5App')
    .directive('slideIn', ['$timeout', 'BREAKPOINTS', 'TRANSITION', function($timeout, BREAKPOINTS, TRANSITION) {
        return {
            restrict: 'A',
            link: function($scope, element, attrs) {
                var transition;
                // Define transition
                transition = TweenMax.to(element, 17 * 2, {
                    useFrames: true,
                    alpha: 1,
                    delay: 30 * 2
                });
            }
        };
    }])
;
